import React, { Component } from "react";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import Select from "react-select";
import cookie from "react-cookies";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import axios from "axios";
import moment from "moment";
import {
  apiUrl,
  adminlimit,
  clientheaderconfig,
  pickupId,
  CountryTxt
} from "../../Helpers/Config";
import { GET_LISTDATA } from "../../../actions";
import {
  showPriceValue,
  showDateTime,
  encodeValue,
  addressFormat,
  showOrderTime,
  showDate,
} from "../../Helpers/SettingHelper";
import Header from "../Layout/Header";
import Topmenu from "../Layout/Topmenu";
import Footer from "../Layout/Footer";
import Pagenation from "../Layout/Pagenation";
var module = "report";

class List extends Component {
  constructor(props) {
    super(props);
    var companyID = cookie.load("companyID");
    var orderType = "c";
    var order_type = this.props.match?.params?.orderType ?? 'today-order';    
    if (this.props.match.params.orderType === "today-order") {
      orderType = "c";
    } else if (this.props.match.params.orderType === "feature-order") {
      orderType = "a";
    }
    

    this.state = {
      moduleName: "Reports",
      companyID: companyID,
      path: this.props.match.path,
      orderType: orderType,
      order_type: order_type,
      totalRecords: 0,
      totalPage: 0,
      currentPage: 1,
      listdata: [],
      orderOutletList: [],
      listsearchdata: [],
      loading: false,
      outletList: [],
      availabiltyList: [],
      statusList: [],
      searchkeyword: "",
      searchoption: "",
      start_date: "",
      end_date: "",
      order_availability: "",
      order_status: "",
      order_outlet: "",
      exportUrl: "",
      overallRevenue:''
    };
    this.handleChangeText = this.handleChangeText.bind(this);
  }
  componentDidMount() {
    this.loadOutlet();
    this.loadAvailabilty();
    this.loadStatusList();
    this.setState({ loading: true }, function () {
      this.loadList(1);
    });
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.listsearchdata !== this.state.listdata) {
      this.setState({
        listdata: nextProps.listdata,
        listsearchdata: nextProps.listdata,
        loading: false,
        totalRecords: nextProps.totalRecords,
        totalPage: nextProps.totalPages,
      });
    }
  }
  loadOutlet() {
    var urlShringTxt = apiUrl + "outlet/dropDownList" ;
    axios.get(urlShringTxt, clientheaderconfig).then((res) => {
      if (res.data.status === "ok") {
        this.setState({ outletList: res.data.result });
      }
    }).catch((e) => {
      console.log(e)
    });
  }
  loadAvailabilty() {
    var urlShringTxt = apiUrl + "availability/companydropDownList";
    axios.get(urlShringTxt, clientheaderconfig).then((res) => {
      if (res.data.status === "ok") {
        this.setState({ availabiltyList: res.data.result });
      }
    }).catch((e) => {
      console.log(e)
    });
  }
  loadStatusList() {
    /* var urlShringTxt = apiUrl + "clientpanel/orders/loadstatus";
    axios.get(urlShringTxt, clientheaderconfig).then((res) => {
      if (res.data.status === "ok") {
        this.setState({ statusList: res.data.result }, function () {});
      }
    }); */
  }

  sateValChange = (field, value) => {
    if (field === "page") {
      this.setState(
        {
          loading: true,
          currentPage: value,
        },
        function () {
          this.loadList(value);
        }
      );
    }
  };
  searchList() {
    this.setState({ loading: true }, function () {
      this.loadList(1);
    });
  }
  loadList(offset) {
    var addParams =
      this.state.searchkeyword !== ""
        ? ("&searchoption=" +
            this.state.searchoption.value +
            "&searchkeyword=" +
            this.state.searchkeyword)
        : "";

    if (
      this.state.order_availability !== null &&
      Object.keys(this.state.order_availability).length > 0
    ) {
      addParams += "&order_availability=" + this.state.order_availability.value;
    }
    if (
      this.state.order_status !== null &&
      Object.keys(this.state.order_status).length > 0
    ) {
      addParams += "&order_status=" + this.state.order_status.value;
    }
    const clientAllowOutlet = cookie.load("clientAllowOutlet") ?? '';
    if (clientAllowOutlet!=="") {
      addParams += "&storeID=" + cookie.load("clientAllowOutlet");
    } else {
      if (
        this.state.order_outlet !== null &&
        Object.keys(this.state.order_outlet).length > 0
      ) {
        addParams += "&storeID=" + this.state.order_outlet.value;
      }
    }

    if (this.state.start_date !== "" && this.state.end_date !== "") {
      addParams +=
        "&start_date=" +
        moment(this.state.start_date).format("Y-MM-DD HH:mm:ss") +
        "&end_date=" +
        moment(this.state.end_date).format("Y-MM-DD HH:mm:ss");
    } else if (this.state.start_date !== "" && this.state.end_date !== "") {
      addParams +=
        "&start_date=" +
        moment(this.state.start_date).format("Y-MM-DD HH:mm:ss");
    }
 

    var params = {
      params: "limit=" + adminlimit + "&offset=" + offset + addParams,
      url: apiUrl + module,
      authType: "client",
    };

    var exportUrl = `${apiUrl}${module}/export?companyID=${this.state.companyID}${addParams}`;
    this.setState({ exportUrl: exportUrl });
    this.props.getListData(params);
    if(offset===1) {
      var urlShringTxt = `${apiUrl}${module}/overAllRevenue/?${addParams}`;
      axios.get(urlShringTxt, clientheaderconfig).then((res) => {
        if (res.data.status === "ok") {
          this.setState({overallRevenue:res.data.orderTotalAmount})
        }else {
          this.setState({overallRevenue:0})
        }
      }).catch((e) => {
        this.setState({overallRevenue:0})
        console.log(e)
      });
    }

  }
  handleSelectChange(name, value) {
    this.setState({ [name]: value });
  }
  handleChangeDate(name, value) {
    this.setState({ [name]: value });
  }
  handleChangeText(event) {
    var name = event.target.name;
    var value = event.target.value;
    this.setState({ [name]: value });
  }
  resetSearch() {
    this.setState(
      {
        loading: true,
        listdata: [],
        searchkeyword: "",
        searchoption: "",
        start_date: "",
        end_date: "",
        order_availability: "",
        order_status: "",
        order_outlet: "",
        totalRecords: 0,
        totalPage: 0,
      },
      function () {
        this.loadList(1);
      }
    );
  }

  render() {
    var checkOrder =
      this.state.listdata.length > 0 && this.state.exportUrl !== ""
        ? true
        : false;
    const clientAllowOutlet_ = cookie.load("clientAllowOutlet") ?? '';
    return (
      <div className="layout-wrapper layout-content-navbar">
        <div className="layout-container">
          <Header {...this.props} currentPage={"order-reports"} />
          <div className="layout-page">
            <Topmenu />

            <div className="content-wrapper">
              <div className="container-xxl flex-grow-1 container-p-y">
                <div className="row mb-3">
                  <div className="col-lg-10 col-md-6">
                    <h4 className="fw-bold">{this.state.moduleName}</h4>
                  </div>
                </div>

                <div className="row mb-1">
                  <div className="col-md-3">
                    <div className="form-floating form-floating-outline custm-select-box filter-select mb-4">
                      <Select
                        value={this.state.searchoption}
                        onChange={this.handleSelectChange.bind(
                          this,
                          "searchoption"
                        )}
                        placeholder="Select Search Option"
                        isClearable={true}
                        options={[
                          { value: "order_number", label: "Order Number" },
                          { value: "customer_name", label: "Customer Name" },
                          { value: "customer_email", label: "Customer Email" },
                          { value: "customer_phone", label: "Customer Phone" },
                        ]}
                      />
                      <label className="select-box-label">Search Option</label>
                    </div>
                  </div>
                  <div className="col-md-3">
                    <div className="form-floating form-floating-outline mb-4">
                      <input
                        type="text"
                        className="form-control"
                        name="searchkeyword"
                        onChange={this.handleChangeText}
                        value={this.state.searchkeyword}
                        id="searchkeyword"
                      />
                      <label htmlFor="searchkeyword">Search Keywords</label>
                    </div>
                  </div>

                  <div className="col-md-3">
                    <div className="form-floating form-floating-outline">
                      <Select
                        placeholder={"Select Availability"}
                        isClearable={true}
                        value={this.state.order_availability}
                        options={this.state.availabiltyList}
                        onChange={this.handleSelectChange.bind(
                          this,
                          "order_availability"
                        )}
                      />
                    </div>
                  </div>
                  <div className="col-md-3">
                    <div className="form-floating form-floating-outline">
                      <Select
                        placeholder={"Select Status"}
                        value={this.state.order_status}
                        options={[
                          {label:"Received", value:1},
                          {label:"Processing", value:2},
                          {label:"Delivering", value:3},
                          {label:"Completed", value:4},
                          {label:"Cancelled", value:5},
                        ]}
                        onChange={this.handleSelectChange.bind(
                          this,
                          "order_status"
                        )}
                        isClearable={true}
                      />
                    </div>
                  </div>
                </div>
                <div className="row mb-4">
                  <div className="col-md-4">
                    <div className="form-floating form-floating-outline">
                      <DatePicker
                        peekNextMonth
                        showMonthDropdown
                        showYearDropdown
                        showTimeSelect
                        dropdownMode="select"
                        className="form-control"
                        selected={this.state.start_date}
                        dateFormat="d-MM-yyyy h:mm aa"
                        placeholderText="Start Date"
                        onChange={this.handleChangeDate.bind(
                          this,
                          "start_date"
                        )}
                      />
                    </div>
                  </div>
                  <div className="col-md-4">
                    <div className="form-floating form-floating-outline">
                      <DatePicker
                        peekNextMonth
                        showMonthDropdown
                        showYearDropdown
                        showTimeSelect
                        dropdownMode="select"
                        className="form-control"
                        selected={this.state.end_date}
                        minDate={
                          this.state.start_date !== ""
                            ? this.state.start_date
                            : ""
                        }
                        dateFormat="d-MM-yyyy h:mm aa"
                        placeholderText="End Date"
                        onChange={this.handleChangeDate.bind(this, "end_date")}
                      />
                    </div>
                  </div>
                  {clientAllowOutlet_!=="" && (
                    <div className="col-md-4">
                      <div className="form-floating form-floating-outline">
                        <Select
                          placeholder={"Select Outlet"}
                          value={this.state.order_outlet}
                          options={this.state.outletList}
                          onChange={this.handleSelectChange.bind(
                            this,
                            "order_outlet"
                          )}
                          isClearable={true}
                        />
                      </div>
                    </div>
                  )}
                </div>
                <div className="row mb-4">
                  <div className="col-md-7 mt-2">
                    <button
                      type="button"
                      className="btn btn-primary me-sm-2 me-1 waves-effect waves-light"
                      onClick={this.searchList.bind(this)}
                    >
                      Search
                    </button>
                    <button
                      type="reset"
                      className="btn btn-label-secondary waves-effect me-sm-2 me-1"
                      onClick={this.resetSearch.bind(this)}
                    >
                      Reset
                    </button>

                    <a
                      href={checkOrder ? this.state.exportUrl : void 0}
                      target="_blank"  rel="noreferrer"
                    >
                      <button
                        type="button"
                        className={`btn btn-info waves-effect waves-light ${
                          !checkOrder ? "disabled" : ""
                        }`}
                      >
                        Export
                      </button>
                    </a>
                    {/* <a
                      href={
                        checkOrder
                          ? this.state.exportUrl + "&itemwise=1"
                          : void 0
                      }
                      target="_blank"
                      className="ml-2"
                    >
                      <button
                        type="button"
                        className={`btn btn-info waves-effect waves-light ${
                          !checkOrder ? "disabled" : ""
                        }`}
                      >
                        Export Item
                      </button>
                    </a> */}
                  </div>
                </div>
                <h4>Revenue:{showPriceValue(this.state.overallRevenue)}</h4>

                <a
                  href="/"
                  className="hidden"
                  data-bs-toggle="modal"
                  data-bs-target="#modalCenter"
                  id="openmodel"
                >
                  Launch modal
                </a>
                <a
                  href="/"
                  className="hidden"
                  data-bs-toggle="modal"
                  data-bs-target="#orderdatetime"
                  id="opentimeslotmodel"
                >
                  Launch modal
                </a>

                <div className="card">
                  <div className="table-responsive text-nowrap p-1 mt-4">
                    <table className="table">
                      <thead>
                        <tr>
                          <th>Order Number</th>
                          <th>Fulfilment Date </th>
                          <th>Created On</th>
                          <th>Outlets</th>
                          <th>Delivery Address</th>
                          <th>Customer Name</th>
                          <th>Customer Email</th>
                          <th>Customer Phone</th>
                          <th>Payment Mode</th>
                          <th>Order Type</th>
                          <th>Status</th>
                          <th>Sub Total</th>
                          <th>Delivery Charge</th>
                          <th>Tax Percentage</th>
                          <th>Tax Type</th>
                          <th>Tax Amount</th>
                          <th>Discount</th>
                          <th>Redeemed Point</th>
                          <th>Redeemed Point Amount</th>
                          <th>Grand Amount</th>
                          <th>Rider</th>
                        </tr>
                      </thead>
                      <tbody>
                        {this.state.loading === true ? (
                          <tr>
                            <td colSpan={11} align="center">
                              <div
                                className="spinner-border spinner-border-lg text-primary"
                                role="status"
                              >
                                <span className="visually-hidden">
                                  Loading...
                                </span>
                              </div>
                            </td>
                          </tr>
                        ) : this.state.listdata.length > 0 ? (
                          this.state.listdata.map((item, index) => {
                           const orderDriverID =  item.orderDriverID ?? '';
                           let orderDate = showDate(item.orderDate)
                           let orderTime = showOrderTime(item.orderDate, item.orderSlotStart, item.orderSlotEnd, item.orderDateType)
                            const displyDate = `${orderDate} ${orderTime}`;

                            return (
                              <tr key={index}>
                                <td>
                                  <strong>
                                    <Link
                                      to={
                                        "/clientpanel/order/today-order" +
                                        this.state.order_type +
                                        "/" +
                                        encodeValue(item._id)
                                      }
                                    >
                                      {item.orderNumber	}
                                    </Link>
                                  </strong>
                                </td>
                                <td>{displyDate}&nbsp;</td>
                                <td>{showDateTime(item.createdAt	)}</td>
                                <td>
                                  {item.outlet?.outletName ?? "N/A"}
                                </td>
                                <td>
                                 {addressFormat(item.orderDeliveryUnitNumber, item.orderDeliveryFloorNumber, item.orderDeliveryAddress, item.orderDeliveryPostalCode, CountryTxt)}
                                </td>
                                <td>{item.orderCustomerFirstName} {item.orderCustomerLastName}</td>
                                <td>{item.orderCustomerEmail}</td>
                                <td>{item.orderCustomerMobile}</td>
                                <td>
                                  {item.orderPaymentMode}
                                  {item.orderPaymentReferenceID	 !== "" &&
                                    item.orderPaymentReferenceID	 !== null && (
                                      <div>
                                        <b>
                                          Payment Ref. No.:
                                          {item.orderPaymentReferenceID	}
                                        </b>
                                      </div>
                                    )}
                                </td>
                                <td>{item.orderAvailabilityName	}</td>
                                <td align="center">
                                  {item.orderAvailabilityID === pickupId && item.orderStatus === 3
                                      ? "Ready to Eat"
                                      : (() => {
                                        if (item.orderStatus === 1) {
                                          return "Received";
                                        } else if (item.orderStatus === 2) {
                                          return "Processing";
                                        } else if (item.orderStatus === 3) {
                                          return "Delivering";
                                        } else if (item.orderStatus === 4) {
                                          return "Completed";
                                        } else if (item.orderStatus === 5) {
                                          return "Cancelled";
                                        }
                                      })()
                                    }
                                </td>
                                <td>{showPriceValue(item.orderSubTotal)}</td>
                                <td>
                                  {showPriceValue(item.orderDeliveryCharge)}
                                </td>
                               
                                <td>{showPriceValue(item.orderTaxPercentage)}</td>
                                <td>
                                  {
                                    item.orderTaxType
                                  }
                                </td>
                                <td>
                                  {showPriceValue(
                                        item.orderTaxAmount
                                      )}
                                </td>
                              
                                <td>
                                  {showPriceValue(item.orderDiscount)}
                                </td>
                                <td>
                                  {item.orderUsedPoints}
                                </td>
                                <td>
                                  {showPriceValue(item.orderUsedPointAmounts)}
                                </td>
                               
                                <td>
                                  {showPriceValue(item.orderGrandTotal)}
                                </td>

                                <td>{orderDriverID!=="" && orderDriverID!==null?(
                                  <>
                                  <b>Driver ID:</b>{orderDriverID}<br/>
                                  <b>Driver Name:</b>{item?.orderDriverName??''}<br/>
                                  <b>Driver Phne:</b>{item?.orderDriverPhone ?? ''}<br/>
                                  </>
                                ):''}</td>
                              </tr>
                            );
                          })
                        ) : (
                          <tr>
                            <td className="text-center" colSpan={11}>
                              No Record Found
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  </div>
                  <Pagenation
                    params={{
                      totalRecords: this.state.totalRecords,
                      totalPage: this.state.totalPage,
                      currentPage: this.state.currentPage,
                    }}
                    sateValChange={this.sateValChange}
                  />
                </div>
              </div>

              <Footer />
            </div>
          </div>
        </div>

        <div className="layout-overlay layout-menu-toggle"></div>
        <div className="drag-target"></div>
      </div>
    );
  }
}

const mapStateTopProps = (state) => {
  var listdata = [];
  var totalPages = 0;
  var totalRecords = 0;
  if (Object.keys(state.listdata).length > 0) {
    if (state.listdata[0].status === "ok") {
      listdata = state.listdata[0].result;
      totalPages = state.listdata[0].totalPages;
      totalRecords = state.listdata[0].totalRecords;
    }
  }
  return {
    listdata: listdata,
    totalPages: totalPages,
    totalRecords: totalRecords,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getListData: (datas) => {
      dispatch({ type: GET_LISTDATA, datas });
    },
  };
};

export default connect(mapStateTopProps, mapDispatchToProps)(List);
